// frontend/src/pages/Home.js
import React, { Fragment } from "react";
import Hero from "./hero/Hero";
import BestSellers from "./best-sellers/BestSellers";
import LatestTitles from "./latest-titles/LatestTitles";
import PopularAuthors from "./popular-authors/PopularAuthors";
import TrendingTitles from "./trending-titles/TrendingTitles";
import OurPartners from "./our-partners/OurPartners";

function Home() {
  return (
    <Fragment>
      <Hero />
      <BestSellers />
      <LatestTitles />
      <TrendingTitles />
      <OurPartners />
      <PopularAuthors />
    </Fragment>
  );
}

export default Home;
